import { array, literal, struct } from 'io-ts/lib/Decoder';

import { LengthCorrectionChoice } from '../length';

/**
 * UI → BE: the user's length correction for one page.
 *
 * A level the Brain Engine prompted per frame sends one choice per frame.
 */
export const LengthCorrectionConfirmed = struct({
	type: literal('length-correction-confirmed'),
	choices: array(LengthCorrectionChoice),
});
